<body class="menu-body">
    <div class="title">
        <h2>{{title}}</h2>
    </div>
    <app-menu-list [meals]="meals"></app-menu-list>
    <br />
    <div *ngFor="let user of users">
        <p>{{user.id}}</p>
        <p>{{user.name}}</p>
        <p>{{user.balance}}</p>
    </div>
</body>